import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { PhoneMask } from './../sharedmodule/directives/phonemasks.directive';


@NgModule({
  declarations: [
    // PhoneMask
  ],
  imports: [
    CommonModule
  ],
  exports:[
    // PhoneMask
  ],
})
export class CommonDirectivesModule { }
